module.exports = __webpack_public_path__ + "img/craftypolarbear-69806d43-fce1-4c5f-d66c-08d957755ecc.png";